var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    attrs: {
      "label": "경매유형",
      "items": _vm.items
    },
    model: {
      value: _vm.mode_auction,
      callback: function ($$v) {
        _vm.mode_auction = $$v;
      },
      expression: "mode_auction"
    }
  }, 'v-select', _vm.attrs_input, false));

}
var staticRenderFns = []

export { render, staticRenderFns }